export const setSelectedItem = (data) => {
    return {
        type: 'USER_SET_SELECTED_ITEM',
        payload: {
            data,
        },
    };
};
export const setSearchValue = (value) => {
    return {
        type: 'USER_SET_SEARCH_VALUE',
        payload: {
            value,
        },
    };
};
export const setTypeItems = (items) => {
    return {
        type: 'USER_SET_TYPE_ITEMS',
        payload: {
            items,
        },
    };
};
export const setItems = (items) => {
    return {
        type: 'USER_SET_ITEMS',
        payload: {
            items,
        },
    };
};
export const addItem = (data) => {
    return {
        type: 'USER_ADD_ITEM',
        payload: {
            data,
        },
    };
};
export const updateItem = (data) => {
    return {
        type: 'USER_UPDATE_ITEM',
        payload: {
            data,
        },
    };
};
export const deleteItem = (id) => {
    return {
        type: 'USER_DELETE_ITEM',
        payload: {
            id,
        },
    };
};
export const setSelectedItemTransportGroupItems = (items) => {
    return {
        type: 'USER_SET_SELECTED_ITEM_TRANSPORT_GROUP_ITEMS',
        payload: {
            items,
        },
    };
};
export const setSelectedItemTransportGroupItem = (id) => {
    return {
        type: 'USER_SET_SELECTED_ITEM_TRANSPORT_GROUP_ITEM',
        payload: {
            id,
        },
    };
};
export const setSelectedItemGeofenceGroups = (items) => {
    return {
        type: 'USER_SET_SELECTED_ITEM_GEOFENCE_GROUPS',
        payload: {
            items,
        },
    };
};
export const setSelectedItemReportAccess = (reportAccess) => {
    return {
        type: 'USER_SET_SELECTED_ITEM_REPORT_ACCESS',
        payload: {
            reportAccess,
        },
    };
};
export const setSelectedItemAutocolonsItems = (items) => {
    return {
        type: 'USER_SET_SELECTED_ITEM_AUTOCOLONS_ITEMS',
        payload: {
            items,
        },
    };
};
